<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Request cash</h1>
    <cash />
  </v-card>
</template>

<script>
import cash from "@/components/back-office/ManagerUserManage/RequstCash.vue";
import { mapState } from "vuex";
export default {
  components: {
    cash,
  },
};
</script>

<style></style>
